import { render, staticRenderFns } from "./mrPhoneLink.vue?vue&type=template&id=5c03a99c&lang=pug&"
import script from "./mrPhoneLink.vue?vue&type=script&lang=js&"
export * from "./mrPhoneLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports